import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { AuthFrame, AuthResult } from '@features/auth/components/AuthExperience';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useRouteError } from 'react-router-dom';

export function LoadingState() {
  const { t } = useTranslation();
  return (
    <Stack
      role="status"
      aria-live="polite"
      spacing={2}
      sx={{ minHeight: '100dvh', alignItems: 'center', justifyContent: 'center' }}
    >
      <CircularProgress size={34} />
      <Typography color="text.secondary">{t('common.loading')}</Typography>
    </Stack>
  );
}

interface StatePageProps {
  icon: React.ReactNode;
  titleKey: string;
  bodyKey: string;
  actionTo?: string;
  actionKey?: string;
}

export function StatePage({
  icon,
  titleKey,
  bodyKey,
  actionTo = '/dashboard',
  actionKey = 'common.backDashboard',
}: StatePageProps) {
  const { t } = useTranslation();
  return (
    <AuthFrame>
      <AuthResult success={false} title={t(titleKey)} message={t(bodyKey)} icon={icon}>
        <RouterLink className="auth-primary" to={actionTo}>
          {t(actionKey)}
        </RouterLink>
      </AuthResult>
    </AuthFrame>
  );
}

export function AccessDeniedPage() {
  return (
    <StatePage
      icon={<LockOutlinedIcon />}
      titleKey="states.accessDenied"
      bodyKey="states.accessDeniedBody"
    />
  );
}
export function SessionExpiredPage() {
  return (
    <StatePage
      icon={<HourglassTopRoundedIcon />}
      titleKey="states.sessionExpired"
      bodyKey="states.sessionExpiredBody"
      actionTo="/login"
      actionKey="auth.signIn"
    />
  );
}
export function NotFoundPage() {
  return (
    <StatePage
      icon={<SearchOffRoundedIcon />}
      titleKey="states.notFound"
      bodyKey="states.notFoundBody"
    />
  );
}
export function GlobalErrorPage() {
  useRouteError();
  return (
    <StatePage
      icon={<ErrorOutlineRoundedIcon />}
      titleKey="states.error"
      bodyKey="states.errorBody"
      actionKey="common.retry"
    />
  );
}
